import { Paper, Box } from "@mui/material";

export default function ChronoSection({ children, ...props }) {
    return (
        <Paper
            elevation={0}
            sx={{
                p: 4,
                borderRadius: "16px",
                border: "1px solid #e5e7eb",
                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                mb: 4,
            }}
            {...props}
        >
            <Box>{children}</Box>
        </Paper>
    );
}
